import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { UserDb } from 'services/user-db.service';
import { LoggingService } from 'services/logging.service';
import { DatabaseWrapper , DocWatcher } from 'services/database-wrapper';
import { DeclaredState } from '@cf-shared/data-model/user-state';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'page-nutrition-options',
  templateUrl: 'nutrition-options-page.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NutritionOptionsPage extends CsPage<{}> implements OnDestroy {
  protected LL = LL;
  protected loading = false;
  declaredState: DeclaredState;
  private docWatcher: DocWatcher;

  constructor(
    public navCtrl: NavController,
    private userDb: UserDb,
    private cd: ChangeDetectorRef,
    private logging: LoggingService,
  ) {
    super();
  }

  async ngOnInit() {
    if (!this.docWatcher) {
      this.docWatcher = this.userDb.database.createDocWatcher((_changes) => {
        if (this.viewDestroyed) return;
        this.cd.markForCheck();
      });
    }
    try {
      this.loading = true;
      this.cd.markForCheck();

      this.declaredState = await this.userDb.loadDeclaredStateAsync(this.docWatcher);

    } finally {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  async ionViewWillEnter() {
    this.loading = true;
    this.cd.markForCheck();

    this.declaredState = await this.userDb.loadDeclaredStateAsync(this.docWatcher);

    this.loading = false;
    this.cd.markForCheck();
  }

  async handleChange() {
    await this.saveChanges();
  }

  private async saveChanges() {
    try {
      await this.userDb.saveDeclaredStateAsync(DatabaseWrapper.getTransactionId());
      // clear backlog cache so nutrition page shows updated targets
      await this.userDb.clearBacklogCacheAsync();
      this.cd.markForCheck();
    } catch (error) {
      // the option on screen says it changed, but it was not saved: tell the person
      this.logging.trackAbnormalException(error);
    }
  }

  ngOnDestroy() {
    this.docWatcher?.destroy();
  }
}
